import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import { Stack } from '@mui/system';
import { LayoutColumn } from 'theme/layouts';
// sections
import Header from './Header';
// reducers
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import {
  intializeBeneficiary,
  getBeneficiaryById,
  getNonePendingBeneficiaries,
  getBeneficiaries,
  getLoadingBeneficiaries,
} from 'state/reducers/beneficiary.reducers';
//components
import { Page } from 'theme/elements/Page';
//constants
import Payments from './payments';
import Details from 'sections/beneficiary/details/beneficiaryDetails';
import { BeneficiaryStatus } from 'constants/beneficiary.constants';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { pagesEnum } from 'constants/ui.constants';
import { loadBeneficiariesPayments } from 'services/pay.services';
import CreateMessage from 'components/CreateMessage';
import { UserPermission } from 'constants/user.constants';
import { getUserPermission } from 'state/reducers/user.reducers';
import MobileNavbar from 'sections/layout/MobileNavbar';
import { getHistory, getMobile, togglePage } from 'state/reducers/ui.reducers';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tab, Tabs, useTheme } from '@mui/material';
import { CustomTabs } from 'theme/elements/Tabs';
import { getUrlBack } from 'theme/elements/Headers';

export default function BeneficiariesDetails() {
  const navigate = useNavigate();
  const t = useAppSelector(selectTranslations);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  //get location
  const paths = location.pathname.split('/');
  const lastPath = paths[paths.length - 1];
  const found = useAppSelector(getBeneficiaryById(lastPath));
  const beneficiaries = useAppSelector(getBeneficiaries);
  const loadBeneficiariesState = useAppSelector(getLoadingBeneficiaries);
  const userPermission = useAppSelector(getUserPermission);
  const [currentTabIdx, setCurrentTabIdx] = useState<string>('0');
  const handleTabChange = (event: React.SyntheticEvent, val: number) => {
    setCurrentTabIdx(String(val));
  };
  const isMobile = useAppSelector(getMobile);
  const history = useAppSelector(getHistory);
  const urlback = getUrlBack(location.pathname, history[history.length - 1]);

  useEffect(() => {
    if (!loadBeneficiariesState.loadingBeneficiaries) {
      if (found) {
        dispatch(intializeBeneficiary(found));
        dispatch(loadBeneficiariesPayments(found.id));
      } else {
        navigate(`/${pagesEnum.BENEFICIARY}`);
      }
    }
  }, [loadBeneficiariesState.loadingBeneficiaries]);

  return (
    <>
      <MobileNavbar
        handleBack={() => {
          dispatch(togglePage(urlback));
        }}
        noCancel
      />
      <Page>
        <Stack spacing={{ sm: 8, xs: 3 }}>
          <Header />
          {isMobile ? (
            <TabContext value={currentTabIdx}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <CustomTabs>
                  <Tabs value={+currentTabIdx} onChange={handleTabChange}>
                    <Tab
                      sx={{ width: '50%' }}
                      id="paymentHistory"
                      tabIndex={0}
                      label={'Payment history'}
                    />
                    <Tab
                      sx={{ width: '50%' }}
                      id="beneficiaryDetails"
                      tabIndex={1}
                      label={'Beneficiary details'}
                    />
                  </Tabs>
                </CustomTabs>
              </Box>
              <TabPanel sx={{ padding: 0, marginTop: '0!important' }} value={'0'}>
                <BeneficiaryPayments found={found} userPermission={userPermission} />
              </TabPanel>
              <TabPanel sx={{ padding: 0, marginTop: '24px!important' }} value={'1'}>
                <Details />
              </TabPanel>
            </TabContext>
          ) : (
            <Stack direction="row" spacing={2}>
              <LayoutColumn width="75%">
                <BeneficiaryPayments found={found} userPermission={userPermission} />
              </LayoutColumn>
              <LayoutColumn width="25%">
                <Details />
              </LayoutColumn>
            </Stack>
          )}
        </Stack>
      </Page>
    </>
  );
}

export function BeneficiaryPayments(props: { found: any; userPermission: UserPermission }) {
  const t = useAppSelector(selectTranslations);
  return (
    <>
      {props.found?.status && !_.isEqual(props.found.status, BeneficiaryStatus.SignedPendingBOApproval) ? (
        <Payments />
      ) : (
        <CreateMessage
          title={t('page.beneficiary.pending.message.title')}
          text={t('message.success.beneficiary_created_and_need_approve')}
          imageKey={'page.beneficiary.pending.icon'}
          noAction={
            !_.includes([UserPermission.OPERATIONER, UserPermission.SIGNER], props.userPermission) ||
            !_.includes(
              [BeneficiaryStatus.Approved, BeneficiaryStatus.ApprovedWithRisk],
              _.get(props.found, 'status')
            )
          }
        />
      )}
    </>
  );
}
